module.exports = __webpack_public_path__ + "img/yewuwaibao.a3e33f18.png";